<script lang="ts">
	import type { ButtonBoxType } from '../types';
	import ButtonBox from './ButtonBox.svelte';
	import { attrValue } from '$lib/utils/html';

	export let props: ButtonBoxType = {};

	$: props = {
		...props,
		classNames: attrValue([props.classNames, 'bg-primary text-white'])
	};
</script>

<ButtonBox {...$$restProps} {props} on:click>
	<slot />
</ButtonBox>
